/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Paid_DetailInputs */

const en_features_paid_detail = /** @type {(inputs: Features_Paid_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1 session · Thursday 18:30`)
};

const pl_features_paid_detail = /** @type {(inputs: Features_Paid_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening 1:1 · czwartek 18:30`)
};

/**
* | output |
* | --- |
* | "1:1 session · Thursday 18:30" |
*
* @param {Features_Paid_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_paid_detail = /** @type {((inputs?: Features_Paid_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Paid_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_paid_detail(inputs)
	return en_features_paid_detail(inputs)
});